import { render, staticRenderFns } from "./VesselsEdit.vue?vue&type=template&id=38c54562&"
import script from "./VesselsEdit.vue?vue&type=script&lang=js&"
export * from "./VesselsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports